import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import React from "react";

let currLevelConfig = {};

export const PizzaModifiersDialog = (props) => {
  const { open, onClose, steps, variations, variationConfig, onAddModifiers } =
    props;
  const [activeStep, setActiveStep] = useState(1);
  const [variationsCopy, setVariationsCopy] = useState([...variations]);

  const handleBack = () => {
    const level = activeStep - 1;
    const maxQuantity = variationConfig["qtyLevel" + level];
    const forcedOption = variationConfig["mandatoryLevel" + level];
    const levelName = variationConfig["nameLevel" + level];

    currLevelConfig = {
      maxQuantity: maxQuantity,
      forcedOption: forcedOption,
      levelName: levelName,
    };
    setActiveStep(level);
  };

  const handleNext = () => {
    const level = activeStep + 1;
    const maxQuantity = variationConfig["qtyLevel" + level];
    const forcedOption = variationConfig["mandatoryLevel" + level];
    const levelName = variationConfig["nameLevel" + level];

    currLevelConfig = {
      maxQuantity: maxQuantity,
      forcedOption: forcedOption,
      levelName: levelName,
    };

    setActiveStep(level);
  };

  const handleDialogClose = () => {
    currLevelConfig = {};
    onClose();
  };

  const handleVariationClick = (id) => {
    let newVariations = [...variationsCopy];
    const index = newVariations.findIndex((x) => x.id === id);
    let variation = newVariations[index];
    //const selectedVariations = newVariations.filter(x => x.)

    if (
      !variation.enabled === true &&
      newVariations.filter((x) => x.level == activeStep && x.enabled === true)
        .length >= currLevelConfig.maxQuantity
    ) {
      console.log("You already selected the max quantity");
      return;
    }

    variation.enabled = !variation.enabled;

    setVariationsCopy(newVariations);
  };

  const handleSaveChanges = () => {
    let productName = "";
    let modifiers = "";
    let finalPrice = 0;
    const selectedVariations = variationsCopy
      .filter((x) => x.enabled === true)
      .sort((a, b) => a.level - b.level);

    selectedVariations.map((x, index) => {
      finalPrice += x.price;
      productName = productName + (index > 0 ? ", " : "") + x.name;
      modifiers = modifiers + (index > 0 ? "\n* " : "* ") + x.name;
    });

    onAddModifiers({
      modifiersDescription: productName,
      modifiersSubititle: modifiers,
      selectedVariations: selectedVariations,
      modifiersPrice: finalPrice,
    });
  };

  useEffect(() => {
    const maxQuantity = variationConfig["qtyLevel1"];
    const forcedOption = variationConfig["mandatoryLevel1"];
    const levelName = variationConfig["nameLevel1"];

    currLevelConfig = {
      maxQuantity: maxQuantity,
      forcedOption: forcedOption,
      levelName: levelName,
    };
  }, []);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Extras</DialogTitle>
      <DialogContent dividers>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection="column"
        >
          <Box sx={{ width: "100%" }}>
            {steps.length > 1 ? (
              <Stepper activeStep={activeStep - 1} sx={{ overflowX: "scroll" }}>
                {steps.map((step, index) => {
                  if (index + 1 === steps.length) {
                    return null;
                  } else {
                    return (
                      <Step key={index}>
                        <StepLabel key={step.level}>{step.label}</StepLabel>
                      </Step>
                    );
                  }
                })}
              </Stepper>
            ) : null}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "inherit",
              }}
            >
              <Typography
                variant={"body2"}
              >{`Please select ${currLevelConfig.maxQuantity} item`}</Typography>
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
              >
                {variationsCopy
                  .filter((x) => x.level === activeStep)
                  .map((x) => {
                    return (
                      <ListItem key={x.id} disablePadding>
                        <ListItemButton
                          key={x.id}
                          role={undefined}
                          onClick={(e) => handleVariationClick(x.id)}
                          dense
                          style={{ height: "60px" }}
                          //   sx={{ fontSize: { xs: "0.675rem", md: "1rem" } }}
                        >
                          <ListItemIcon key={x.id}>
                            <Checkbox
                              key={x.id}
                              edge="start"
                              checked={x.enabled}
                              tabIndex={-1}
                              disableRipple
                              style={{ transform: "scale(1.5)" }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            key={x.id + x.name}
                            id={x.labelId}
                            primary={`${x.name} ($${x.price.toFixed(2)})`}
                            sx={{
                              fontSize: {
                                xs: "0.475rem",
                                md: "0.6rem",
                                lg: "0.6rem",
                              },
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
              </List>
            </div>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              {steps.length > 1 && activeStep > 1 ? (
                <Button
                  color="inherit"
                  disabled={activeStep === 1}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                >
                  Back
                </Button>
              ) : null}

              <Box sx={{ flex: "1 1 auto" }} />

              {/* <AlertPopUp show={showPopUp} /> */}
              {activeStep === steps.length - 1 ? null : (
                <Button
                  onClick={handleNext}
                  disabled={
                    variationsCopy.filter(
                      (x) => x.level == activeStep && x.enabled === true
                    ).length <= 0
                  }
                >
                  Next
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button color="error" onClick={() => handleDialogClose()}>
          Cancel
        </Button>
        <Button
          onClick={handleSaveChanges}
          disabled={activeStep < steps.length - 1}
        >
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
